module.exports = __webpack_public_path__ + "img/logo.0218d8a1.png";